import ListView from '@/components/datagrid/ListView';
import useTitle from '../../../../hooks/useTitle';
import { Delete } from '@mui/icons-material';
import useTenantQuery from '@/hooks/useTenantQuery';
import { useRouteLoaderData } from 'react-router-dom';
import { Avatar, Box, Chip } from '@mui/material';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import useAppStore from '@/store/app';
import TenantTeamDialog from '@/components/forms/tenants/TenantTeamDialog';
import TenantTeamsDetail from '@/components/forms/tenants/TenantTeamsDetail';
import { useState } from 'react';
import useTenantDelete from '@/hooks/useTenantDelete';

export default function Teams() {
  useTitle('Teams');
  const { users } = useRouteLoaderData('auth');
  const { isPending, data: teams } = useTenantQuery('team');
  const { mutateAsync: deleteCallback } = useTenantDelete(`team`);

  const [selectedRows, setSelectedRows] = useState([]);
  const { selectedItem, setSelectedItem } = useAppStore();

  const { setDialogForm } = useAppStore();

  const rows = teams || [];

  const handleDelete = () => {
    selectedRows.forEach((id) => {
      if (selectedItem === id) {
        setSelectedItem(null);
      }
      deleteCallback(id);
    });
    setSelectedRows([]);
  };

  const columns = [
    {
      field: 'title',
      headerName: 'Name',
      flex: 2,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'members',
      headerName: 'Mitglieder',
      flex: 2,
      type: 'number',
      headerAlign: 'left',
      align: 'left',
      valueGetter: (params) => {
        return Array.isArray(params) ? params.length : 0;
      },
    },
    {
      field: 'managers',
      headerName: 'Teamleiter',
      flex: 6,
      type: 'string',
      headerAlign: 'left',
      align: 'left',
      valueGetter: (params) => {
        const managerField = params;
        if (Array.isArray(managerField)) {
          return users.filter((u) => managerField.includes(u._id));
        }
      },
      renderCell: (params) => {
        const managers = params.value;
        if (!managers || managers.length === 0) {
          return 'Keine Teamleiter';
        }

        return (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              height: '100%',
              gap: 0.5,
            }}
          >
            {managers.map((user) => (
              <Chip
                key={user._id}
                avatar={
                  <Avatar
                    src={
                      user.profilePicture
                        ? `${import.meta.env.VITE_FILE_URL}/${user.profilePicture}`
                        : undefined
                    }
                    alt={`${user.firstName} ${user.lastName}`}
                  />
                }
                label={`${user.firstName} ${user.lastName}`}
                variant="outlined"
              />
            ))}
          </Box>
        );
      },
    },
  ];

  const actions = [
    {
      title: 'Hinzufügen',
      label: 'Hinzufügen',
      icon: GroupAddOutlinedIcon,
      variant: 'contained',
      onClick: () => {
        setDialogForm(<TenantTeamDialog />);
      },
      group: 'primary',
    },
    {
      title: 'Löschen',
      label: 'Löschen',
      color: 'error',
      selection: 'multi',
      icon: Delete, onClick: handleDelete
    },];

  return (
    <ListView
      rows={rows}
      columns={columns}
      actions={actions}
      loading={isPending}
      detailComponents={[{ Component: TenantTeamsDetail, title: 'Details' }]}
      setSelectedRows={setSelectedRows}
      selectedRows={selectedRows}
    />
  );
}
